module.exports = __webpack_public_path__ + "img/niño82.8c82aefc.jpg";